import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/Primitives";

export default function NotFound() {
    return (
        <>
            <Seo
                title="Page not found"
                description="The page you were looking for doesn't exist."
                path="/404"
            />
            <section className="min-h-[70vh] flex items-center px-5 sm:px-8 lg:px-16">
                <div className="mx-auto max-w-[1180px] w-full">
                    <Eyebrow>Error 404</Eyebrow>
                    <h1 className="mt-6 font-display font-black tracking-tight text-6xl sm:text-7xl lg:text-8xl">
                        Nothing here
                    </h1>
                    <p className="mt-6 text-lg text-pa-ink-500 max-w-lg">
                        The page you were looking for doesn't exist — or it
                        moved when the site was rebuilt.
                    </p>
                    <div className="mt-9 flex flex-wrap gap-4">
                        <Link
                            to="/"
                            data-testid="notfound-home"
                            className="group inline-flex items-center gap-2 bg-pa-blue-600 text-white px-6 py-3 cut-tr hover:bg-pa-blue-700 transition-colors font-medium"
                        >
                            Back to home
                            <span className="transition-transform group-hover:translate-x-1">
                                →
                            </span>
                        </Link>
                        <Link
                            to="/contact"
                            data-testid="notfound-contact"
                            className="inline-flex items-center gap-2 border border-pa-blue-600 text-pa-blue-700 px-6 py-3 cut-tr hover:bg-pa-blue-050 transition-colors font-medium"
                        >
                            Contact us
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
